import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "label" }
const _hoisted_2 = {
  key: 1,
  class: "remind-ball"
}
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_ctx.item)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["form-components", {'el-form-item is-error':_ctx.store.state.errorFileList.includes(_ctx.item.field)}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.item.remark||_ctx.stateFieldRemark[_ctx.item.field])
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: _ctx.item.remark||_ctx.stateFieldRemark[_ctx.item.field],
                "popper-class": "remark-popper",
                placement: "top-start",
                trigger: "click"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: "https://images.goworkla.cn/wxAppletImg/EnergyValue_result_about.png",
                    class: "label-remark"
                  }, null, -1)
                ])),
                _: 1,
                __: [1]
              }, 8, ["content"]))
            : _createCommentVNode("", true),
          (_ctx.item.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true),
          _createTextVNode(_toDisplayString(_ctx.item.name), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.datavalue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datavalue) = $event)),
            type: _ctx.item.field==='noviciate_time'?'month':'date',
            style: {"width":"100%"},
            placeholder: _ctx.item.prompt_msg,
            disabled: _ctx.item.is_disable,
            "disabled-date": _ctx.disabledDate,
            "value-format": _ctx.item.field==='noviciate_time'?'YYYY-MM':'YYYY-MM-DD',
            onChange: _ctx.change
          }, null, 8, ["modelValue", "type", "placeholder", "disabled", "disabled-date", "value-format", "onChange"])
        ])
      ], 2))
    : _createCommentVNode("", true)
}